import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogListHero from './components/BlogListHero';
import BlogGrid from './components/BlogGrid';
import BlogCTA from './components/BlogCTA';

export default function BlogList() {
  useEffect(() => {
    // Update meta tags
    document.title = 'Knowledge Hub - Technical Insights for Vancouver Construction | Dinari Designs';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert insights on AutoCAD drafting, Bluebeam takeoffs, formwork design, and construction best practices for Vancouver projects. Professional technical guidance from industry specialists.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'construction blog, AutoCAD tips, Bluebeam Revu, formwork design, Vancouver construction, technical drafting, material takeoffs');
    }

    // Add Schema.org JSON-LD for Blog
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Blog',
      name: 'Dinari Designs Knowledge Hub',
      description: 'Expert insights on AutoCAD drafting, Bluebeam takeoffs, formwork design, and construction best practices for Vancouver projects.',
      publisher: {
        '@type': 'Organization',
        name: 'Dinari Designs',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/f0c3f25d25166b296c2998ed1e07db56/4ed16d38f79ad8245b8fcfc88558374a.jfif',
        },
      },
      url: window.location.href,
    });

    if (!document.head.querySelector('script[data-schema="blog-list"]')) {
      script.setAttribute('data-schema', 'blog-list');
      document.head.appendChild(script);
    }

    return () => {
      const schemaScript = document.head.querySelector('script[data-schema="blog-list"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BlogListHero />
      <BlogGrid />
      <BlogCTA />
      <Footer />
    </div>
  );
}
